import Tasks from 'APP/Tasks';

import { GroupsEvent } from '../GroupsEvent';

export class Group extends GroupsEvent {
  process() {
    Tasks.group.loadGroupsByIds([this.groupId]);
  }
}
